import { module } from "angular";

import type { IEnumService } from "./IEnumService";

export default class EnumService implements IEnumService {
    public static $inject: string[] = [];

    public enumToArray(enumType: any): Array<{ key: number; value: string }> {
        const enumArray: Array<{ key: number; value: string }> = [];
        // eslint-disable-next-line no-restricted-syntax
        for (const key in enumType) {
            if (!enumType.hasOwnProperty(key)) {
                continue;
            }

            const numericKey = Number(key);
            // eslint-disable-next-line no-restricted-globals
            if (isNaN(numericKey)) {
                break;
            }
            enumArray.push({ key: numericKey, value: enumType[numericKey] });
        }

        return enumArray;
    }
}

module("mmModels").service("mmEnumService", EnumService);
